export default __webpack_public_path__ + "static/media/new-message.34115496.mp3";